import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { AutoCompleteConfig } from 'app/core/ui/components/autocomplete/config/autocomplete.config';
import { ConcessaoVeiculoService } from 'app/services/mob/concessao-veiculo.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'autocomplete-prefixo',
  templateUrl: './autocomplete-prefixo.component.html',
  styleUrls: ['./autocomplete-prefixo.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class AutocompletePrefixoComponent implements OnInit {

  formGroup: FormGroup;
  cdConcessaoSolicitante: number;

  inputPatternConcessinario = /[^A-Z0-9]/g;

  autoCompletePrefixoConfig = new AutoCompleteConfig({
    service: this._concessaoVeiculoService,
    keyword: 'nrPrefixo',
    useLabel: 'nrPrefixo',
    useValue: 'cdConcessaoVeiculo'
  });

  constructor(
    private _concessaoVeiculoService: ConcessaoVeiculoService,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('cdConcessaoVeiculo').updateValueAndValidity();
    this.buscarDadosConcessao();
  }

  private buscarDadosConcessao() {
    this.formGroup.get('cdConcessaoVeiculo').valueChanges.subscribe(cdConcessaoVeiculo => {
      if (cdConcessaoVeiculo) {
        this._concessaoVeiculoService.get(cdConcessaoVeiculo).then(concessaoVeiculoDTO => {
          this.formGroup.get('cdConcessao').setValue(concessaoVeiculoDTO.cdConcessao);
          this.formGroup.get('cdVeiculo').setValue(concessaoVeiculoDTO.cdVeiculo);
          this.formGroup.get('nrPrefixo').setValue(concessaoVeiculoDTO.nrPrefixo);
        })
      }
    })
  }
}
